<template>
  <div
      v-if="type!=='hidden' && type!=='plainText' && display && showComponent"
      :title="qaAble ? showIfHasPermission?.toString() : null"
      :key="componentRefresh"
      :class="[containerClasses]"
      :style="{'margin':margin, 'padding':padding, 'height':height, 'width':width}"
  >
    <label v-if="label!==null" :class="[labelClasses]">
      <i class="m1" :class="[tooltipIcon]" :title="tooltip" v-if="tooltip!==null&&tooltipLeft&&!tooltipRight"></i>
      {{ label }}
      <span style="color:red">{{ required ? '*' : '' }}</span>
      <i class="m1" :class="[tooltipIcon]" :title="tooltip" v-if="tooltip!==null&&tooltipRight"></i>
    </label>
    <template v-if="type!='textarea' && type !='rte' && type != 'phone' && type !='currency'">
      <template v-if="hasSlotSuffix || hasSlotPrefix">
        <div class="input-group">
          <div :class="[slotClasses]" v-if="hasSlotPrefix">
            <slot name="prefix" v-if="hasSlotPrefix"></slot>
          </div>
          <input v-if="mask"
                 :ref="'field_id' + id"
                 v-mask="mask"
                 class="form-control"
                 :class="[inputClasses, computedValidationStatus]"
                 :type="type"
                 :placeholder="placeholder"
                 v-model="input"
                 :required="required"
                 :disabled="disabled||!enableComponent"
                 :readonly="readOnly"
                 @click="onClick"
                 @change="onChange"
                 @focus="onFocus"
                 @blur="onBlur"
                 @keyup="onKeyPress"
                 @keypress.enter.prevent="onKeyPressEnter"
                 @keydown.tab="onKeyDownTab"
                 :style="{'margin':margin, 'padding':padding, 'height':height, 'width':width}"
                 :autocomplete="autocomplete"
          >
          <input v-else
                 :ref="'field_id' + id"
                 class="form-control"
                 :class="[inputClasses, computedValidationStatus]"
                 :type="type"
                 :placeholder="placeholder"
                 v-model="input"
                 :required="required"
                 :disabled="disabled||!enableComponent"
                 :readonly="readOnly"
                 @click="onClick"
                 @change="onChange"
                 @focus="onFocus"
                 @blur="onBlur"
                 @keyup="onKeyPress"
                 @keypress.enter.prevent="onKeyPressEnter"
                 @keydown.tab="onKeyDownTab"
                 :style="{'margin':margin, 'padding':padding, 'height':height, 'width':width}"
                 :autocomplete="autocomplete"
          >
          <div :class="[slotClasses]" v-if="hasSlotSuffix">
            <slot name="suffix" v-if="hasSlotSuffix"></slot>
          </div>
        </div>
      </template>
      <template v-else>
        <input v-if="mask"
               :ref="'field_id' + id"
               v-mask="mask"
               class="form-control"
               :class="[inputClasses, computedValidationStatus]"
               :type="type"
               :placeholder="placeholder"
               v-model="input"
               :required="required"
               :disabled="disabled||!enableComponent"
               :readonly="readOnly"
               @click="onClick"
               @change="onChange"
               @focus="onFocus"
               @blur="onBlur"
               @keyup="onKeyPress"
               @keypress.enter.prevent="onKeyPressEnter"
               @keydown.tab="onKeyDownTab"
               :style="{'margin':margin, 'padding':padding, 'height':height, 'width':width}"
               :autocomplete="autocomplete"
        >
        <input v-else
               :ref="'field_id' + id"
               class="form-control"
               :class="[inputClasses, computedValidationStatus]"
               :type="type"
               :placeholder="placeholder"
               v-model="input"
               :required="required"
               :disabled="disabled||!enableComponent"
               :readonly="readOnly"
               @click="onClick"
               @change="onChange"
               @focus="onFocus"
               @blur="onBlur"
               @keyup="onKeyPress"
               @keypress.enter.prevent="onKeyPressEnter"
               @keydown.tab="onKeyDownTab"
               :style="{'margin':margin, 'padding':padding, 'height':height, 'width':width}"
               :autocomplete="autocomplete"
        >
      </template>
    </template>
    <template v-else-if="type == 'textarea'">
      <textarea v-if="mask"
                :ref="'field_id' + id"
                v-mask="mask"
                class="form-control"
                :class="[inputClasses, computedValidationStatus]"
                :rows="rows"
                v-model="input"
                :required="required"
                :disabled="disabled||!enableComponent"
                :readonly="readOnly"
                @click="onClick"
                @change="onChange"
                @focus="onFocus"
                @blur="onBlur"
                @keyup="onKeyPress"
                @keypress.enter.prevent="onKeyPressEnter"
                @keydown.tab="onKeyDownTab"
                :style="{'margin':margin, 'padding':padding, 'height':height, 'width':width}"
      >
      </textarea>
      <textarea v-else
                :ref="'field_id' + id"
                class="form-control"
                :class="[inputClasses, computedValidationStatus]"
                :rows="rows"
                v-model="input"
                :required="required"
                :disabled="disabled||!enableComponent"
                :readonly="readOnly"
                @click="onClick"
                @change="onChange"
                @focus="onFocus"
                @blur="onBlur"
                @keyup="onKeyPress"
                @keypress.enter.prevent="onKeyPressEnter"
                @keydown.tab="onKeyDownTab"
                :style="{'margin':margin, 'padding':padding, 'height':height, 'width':width}"
      >
      </textarea>
    </template>
    <template v-else-if="type == 'rte'" style="height: 100%;">
      <template v-if="showRteTabs">
        <ul class="nav nav-tabs justify-content-end">
          <li class="nav-item">
            <a class="nav-link active pointer" data-toggle="tab" data-target="#home" v-on:click="showWysiwyg = true">Rich
              Text</a>
          </li>
          <li class="nav-item">
            <a class="nav-link pointer" data-toggle="tab" data-target="#menu1" v-on:click="showWysiwyg = false">HTML</a>
          </li>
        </ul>
        <div class="tab-content" style="height: calc(100% - 54px);">
          <div class="active" id="home" v-if="showWysiwyg" style="height: calc(100% - 46px);">
            <ks-spinner :ref="'input_rich_editor'+_uid"/>
            <vue-editor
                v-show="screenSizeId >= 3"
                use-custom-image-handler
                style="width: 100%; height: 100%;"
                ref="rte_ref"
                v-model="input"
                :required="required"
                :disabled="disabled||!enableComponent"
                :readonly="readOnly"
                click="onClick"
                @change="onChange"
                @focus="onFocus"
                @blur="onBlur"
                @keyup="onKeyPress"
                @keypress.enter="onKeyPressEnter"
                @keydown.tab="onKeyDownTab"
                @image-added="imageAdded"
            />
            <vue-editor
                v-show="screenSizeId < 3"
                style="width: 100%; height: 100%;"
                ref="rte_ref2"
                v-model="input"
                :required="required"
                :disabled="disabled||!enableComponent"
                :readonly="readOnly"
                click="onClick"
                @change="onChange"
                @focus="onFocus"
                @blur="onBlur"
                @keyup="onKeyPress"
                @keypress.enter="onKeyPressEnter"
                @keydown.tab="onKeyDownTab"
                :editorOptions="editorSettingsSmall"
                use-custom-image-handler
                @image-added="imageAdded"
            />
          </div>
          <div class="fade" id="menu1" v-else style="height: 100%;">
                      <textarea
                          style="width: 100%; height: 100%;"
                          class="form-control"
                          :class="[inputClasses, computedValidationStatus]"
                          :rows="rows"
                          v-model="input"
                          :required="required"
                          :disabled="disabled||!enableComponent"
                          :readonly="readOnly"
                          @click="onClick"
                          @change="onChange"
                          @focus="onFocus"
                          @blur="onBlur"
                          @keyup="onKeyPress"
                          @keypress.enter="onKeyPressEnter"
                          @keydown.tab="onKeyDownTab"
                      >
                      </textarea>
          </div>
        </div>
      </template>
      <template v-else>
        <ks-spinner :ref="'input_rich_editor'+_uid"/>
        <vue-editor
            v-show="screenSizeId >= 3"
            use-custom-image-handler
            style="width: 100%; height: 100%;"
            ref="rte_ref"
            v-model="input"
            :required="required"
            :disabled="disabled||!enableComponent"
            :readonly="readOnly"
            click="onClick"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
            @keyup="onKeyPress"
            @keypress.enter="onKeyPressEnter"
            @keydown.tab="onKeyDownTab"
            @image-added="imageAdded"
        />
        <vue-editor
            v-show="screenSizeId < 3"
            style="width: 100%; height: 100%;"
            ref="rte_ref2"
            v-model="input"
            :required="required"
            :disabled="disabled||!enableComponent"
            :readonly="readOnly"
            click="onClick"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
            @keyup="onKeyPress"
            @keypress.enter="onKeyPressEnter"
            @keydown.tab="onKeyDownTab"
            :editorOptions="editorSettingsSmall"
            use-custom-image-handler
            @image-added="imageAdded"
        />
      </template>
    </template>
    <template v-else-if="type == 'phone'">
      <div class="input-group" :class="[inputClasses, computedValidationStatus]"
           :style="{'margin':margin, 'padding':padding, 'height':height, 'width':width}">
        <div class="input-group-prepend" v-if="showCountryCodeSelector">
          <button v-if="activeCountryCode !== null"
                  class="btn btn-xs btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  :disabled="!enableCountryCodeSelector||disabled||!enableComponent"
          >
            <img :src="activeCountryCode.flag" height="25" width="25"> +{{ activeCountryCode.code }}
          </button>
          <div class="dropdown-menu">
            <a v-for="ccode in countryCodes" class="dropdown-item" href="" @click.prevent="activeCountryCode = ccode">
              <img :src="ccode.flag" height="25" width="25"> +{{ ccode.code }}
            </a>
          </div>
        </div>
        <input
            type="tel"
            inputmode="numeric" 
            pattern="[0-9]*"
            v-mask="mask"
            class="form-control"
            :placeholder="placeholder"
            v-model="phoneInput"
            :maxlength="14"
            :required="required"
            :disabled="disabled || !enableComponent"
            :readonly="readOnly"
            @click="onClick"
            @change="onChange"
            @focus="onFocus"
            @blur="onBlur"
            @keyup="onKeyPress"
            @keypress.enter.prevent="onKeyPressEnter"
            @keydown.tab="onKeyDownTab"
            :autocomplete="autocomplete"
        >
      </div>
    </template>
    <template v-if="type === 'currency'">
      <div class="input-group">
        <div class="input-group-prepend" style="min-height: 36px; max-width: 100%;">
          <span class="input-group-text"> <i class="fas fa-dollar-sign"></i> </span>
          <currency-input
              class="currency"
              v-model="input"
              :currency="currency"
              :locale="locale"
          />
        </div>
      </div>
    </template>


    <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
    <div class="valid-feedback" v-if="computedValidationStatus==='is-valid'">
      <ul>
        <li v-for="(text, index) in validText" :key="_uid+'success_'+index">{{ text }}</li>
      </ul>
    </div>
    <div class="invalid-feedback" v-if="computedValidationStatus==='is-invalid'">
      <ul>
        <li v-for="(text, index) in invalidText" :key="_uid+'error_'+index">{{ text }}</li>
      </ul>
    </div>
  </div>
  <div v-else-if="type=='hidden' && display">
    <input type="hidden" v-model="input">
  </div>
  <div v-else-if="display && showComponent" class="form-group" :class="[containerClasses]">
    <label v-if="label!==null" :class="[labelClasses]">{{ label }}</label>
    <p readonly class="form-control-plaintext" :class="[inLine?inputClasses:'']">
      <template v-if="!!$slots.default">
        <slot></slot>
      </template>
      <template v-else>
        <template v-if="mask">
          {{ input | mask(mask) }}
        </template>
        <template v-else>
          {{ input }}
        </template>
      </template>
    </p>
  </div>
</template>
<script>
import Vue from 'vue'
import {mask} from 'vue-the-mask'
import {VueEditor, Quill} from 'vue2-editor'
import checkPermissions from '../../mixins/checkPermissions';
import phoneFormat from '../../mixins/phoneFormat';
import {CurrencyInput} from 'vue-currency-input'

Vue.directive('mask', mask);
export default {
  name: 'input-field',
  mixins: [checkPermissions, phoneFormat],
  props: {
    value: {default: null},
    formGroup: {
      type: Boolean,
      default: true
    },
    showRteTabs: {
      type: Boolean,
      default: true
    },
    currency: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: 'en'
    },
    set_rte_focus: {
      type: Boolean,
      default: false
    },
    set_rte_config: {
      type: Object,
      default: () => {
        return {
          uploadImage: {
            campaign_id: null,
            object_type_id: null,
            object_id: null,
            transform_type_id: 1
          }
        }
      }
    },
    tooltip: {
      type: String,
      default: null
    },
    tooltipIcon: {
      type: String,
      default: 'fas fa-question-circle'
    },
    tooltipRight: {
      type: Boolean,
      default: true
    },
    tooltipLeft: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: null
    },
    mask: {
      type: String,
      default: null
    },
    validation: {
      default: null
    },
    size: {
      type: String, //sm-lg-md
      default: null
    },
    inLine: {
      type: Boolean,
      default: false
    },
    inlineLabelColClass: {
      type: String,
      default: 'col'
    },
    inlineInputColClass: {
      type: String,
      default: 'col'
    },
    dataSource: {
      type: String,
      default: null
    },
    dataSourceCountryCode: {
      type: String,
      default: null
    },
    defaultValue: {
      default: null
    },
    label: {
      type: String,
      default: null
    },
    boldLabel: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      required: true
    },
    rows: {
      type: String
    },
    placeholder: {
      type: String
    },
    helpText: {
      type: String,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    display: {
      type: Boolean,
      default: true
    },
    classes: {
      type: String,
      default: null
    },
    margin: {
      type: String,
      default: null
    },
    padding: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: null
    },
    focus: {
      type: Boolean,
      default: false
    },
    countryCode: {
      default: 'eeuu'
    },
    showCountryCodeSelector: {
      type: Boolean,
      default: true
    },
    enableCountryCodeSelector: {
      type: Boolean,
      default: true
    },
    validationOnChange: {
      type: Boolean,
      default: false
    },
    validationOnBlur: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    autocomplete: {
      type: String,
      default: "new-password"
    }
  },
  components: {VueEditor, Quill, CurrencyInput},
  watch: {
    defaultValue: function (val, oldVal) {
      this.input = this.defaultValue;
    },
    input: function (val, oldVal) {
      this.$emit('onInput', this);
      /*if (this.defaultValue !== null && val === undefined) {
        this.input = this.defaultValue;
      }*/
      if (this.validationOnChange) {
        this.validate_input();
      }
      //if is enabled vue-editor
      if (this.type == 'rte' && val && val.length > 0) {
        this.base64ToURL(val);
      }
    },
    set_rte_focus: function (val, oldVal) {
      let quill = this.screenSizeId >= 3 ? this.$refs.rte_ref.quill : this.$refs.rte_ref2.quill;
      setTimeout(function () {
        quill.focus();
      });
    },
    focus: function (val, oldVal) {
      if (this.focus) {
        setTimeout(() => {
          this.$refs["field_id" + this._uid].focus();
          /*this.$nextTick(() => {
            const editButtonRef = this.$refs.editButton;
            editButtonRef.focus();
          });*/

          /*$('#field_id' + this._uid).focus()*/
        }, 1000);

      }
    },
  },
  computed: {
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    },
    screenSizeId() {
      return app.layout.screenSizeId;
    },
    dataProvider() {
      return this.$parent.data_provider_ref;
    },
    inputType() {
      return this.$parent.type;
    },
    input: {
      get() {
        if (this.dataSource == null) return this.l_input;
        if (this.inputType === 'list') {
          let val = this.$parent.data_provider_ref[this.inputType][this.index][this.dataSource];
          if (this.type === 'phone') {
            val = val ? this.phoneFormat(val) : val;
          }
          return val;
        } else {
          let val = this.$parent.data_provider_ref[this.inputType][this.dataSource];
          if (this.type === 'phone') {
            val = val ? this.phoneFormat(val) : val;
          }
          if (val && val.length > 0 && this.type === 'phone') {
            this.phoneInput = val[0] == 1 ? val.substring(1) : val;
          }
          return val;
        }
      },
      set(newval) {
        let aux = this.unmask(newval);
        if (this.type == 'phone' && aux.length === 10 && this.dataSourceCountryCode === null) {
          //We're going to store the country code in a separate field.
          aux = `${this.activeCountryCode ? this.activeCountryCode.code : "1"}${aux}`
        }
        if (this.dataSource) {
          if (this.inputType === 'list') {
            this.$set(this.$parent.data_provider_ref[this.inputType][this.index], this.dataSource, aux);
          } else {
            this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, aux);
          }
        } else {
          this.l_input = aux;
          this.$emit('input', this.l_input);
        }
      }
    },
    computedValidationStatus() {
      return this.isValid === null ? "none" : this.isValid === true ? "" : "is-invalid"; /*is-valid*/
    },
    containerClasses() {
      return `${this.inLine ? 'row' : ''} ${this.classes ? this.classes : ''} ${this.formGroup ? 'form-group' : ''}`;
    },
    labelClasses() {
      let sizeClass = this.size ? `col-form-label-${this.size}` : '';
      let inlineClass = this.inLine ? `${this.inlineLabelColClass} col-form-label` : ''
      let boldLabel = this.boldLabel ? 'font-weight-bold' : '';
      return `${sizeClass} ${inlineClass} ${boldLabel}`;
    },
    inputClasses() {
      let sizeClass = this.size ? `form-control-${this.size}` : '';
      let inlineClass = this.inLine ? `${this.inlineInputColClass}` : '';
      return `${sizeClass} ${inlineClass}`;
    },
    hasSlotPrefix() {
      return !!this.$slots.prefix;
    },
    hasSlotSuffix() {
      return !!this.$slots.suffix;
    },
    slotClasses() {
      return this.hasSlotPrefix ? 'input-group-prepend' : this.hasSlotSuffix ? 'input-group-append' : null;
    }
  },
  mounted() {
    if (this.type == 'phone') {
      if (this.dataSourceCountryCode) {
        this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSourceCountryCode, '1');
      }
      this.activeCountryCode = this.countryCodes.find((cc) => cc.code === `${this.countryCode}`.trim());
      if (!this.activeCountryCode) {
        this.activeCountryCode = this.countryCodes[0];
      }
    }
    this.id = this._uid;
    if (this.defaultValue !== null) {
      this.$set(this.$parent.data_provider_ref[this.inputType], this.dataSource, this.defaultValue);
    }
    this.$emit('onMounted', this);
    setTimeout(() => {
      this.dataProvider.inputs[this.dataSource] = this;
    }, 500);
  },
  methods: {
    async base64ToURL(str) {
      try {
        let base64Images = this.verifyCacheImages(str.match(/(data:image\/[^;]+;base64[^"]+)/g));
        if (base64Images && base64Images.length > 0) {
          let files = [];
          //this.$refs['input_rich_editor' + this._uid].show();
          for (let image of base64Images) {
            files.push(await this.urlToFile(image, `${new Date().getTime()}.png`, "image/png"));
          }
          let res = await this.uploadFile(files);
          let i = 0;
          let newStr = str;
          for (let image of base64Images) {
            newStr = newStr.replace(image, `${app.apiURL}/file/files/${this.set_rte_config.uploadImage.campaign_id}/${res.created_files[i].id}`);
            this.cacheImages.push({
              image64: image,
              urlImage: res.created_files[i].id
            })
            i++;
          }
          this.input = newStr;
          this.$refs['input_rich_editor' + this._uid].hide();
        }
      } catch (err) {
        this.$refs['input_rich_editor' + this._uid].hide();
        console.log('KS-APP: ', err);
      }
    },
    verifyCacheImages(images64) {
      let arrayImages = [];
      if (images64 && images64.length > 0) {
        for (let image of images64) {
          let index = this.cacheImages.length > 0 ? this.cacheImages.findIndex(ci => ci.image64 == image) : -1;
          if (index == -1) {
            arrayImages.push(image);
          } else {
            this.input = this.input.replace(this.cacheImages[index].image64, `${app.apiURL}/file/files/${this.set_rte_config.uploadImage.campaign_id}/${this.cacheImages[index].urlImage}`);
          }
        }
      }
      return arrayImages;
    },
    urlToFile(url, filename, mimeType) {
      return (fetch(url)
              .then(function (res) {
                return res.arrayBuffer();
              })
              .then(function (buf) {
                return new File([buf], filename, {type: mimeType});
              })
      );
    },
    async uploadFile(files) {
      try {
        return await app.sdk.file.file_create(app.auth.urlToken, {
          campaign_id: this.set_rte_config.uploadImage.campaign_id,
          object_type_id: this.set_rte_config.uploadImage.object_type_id,
          object_id: this.set_rte_config.uploadImage.object_id,
          transform_type_id: typeof this.set_rte_config.uploadImage.transform_type_id !== 'undefined' ? this.set_rte_config.uploadImage.transform_type_id : 1,
        }, null, files);
      } catch (err) {
        console.log('KS-APP: ', err);
        throw err;
      }
    },
    async imageAdded(file, Editor, cursorLocation, resetUploader) {
      try {
        this.$refs['input_rich_editor' + this._uid].show();
        let fileExtension = file.name.split('.').pop()
        let fileName = file.name.replace(`.${fileExtension}`, '');
        let renameFile = new File([file], `${fileName}_${new Date().getTime()}.${fileExtension}`, {
          type: file.type,
          lastModified: file.lastModified
        });
        let res = await this.uploadFile([renameFile]);
        Editor.insertEmbed(cursorLocation, "image", `${app.apiURL}/file/files/${this.set_rte_config.uploadImage.campaign_id}/${res.created_files[0].id}`);
        resetUploader();
        this.$refs['input_rich_editor' + this._uid].hide();
      } catch (err) {
        this.$refs['input_rich_editor' + this._uid].hide();
        console.log('KS-APP: ', err);
      }
    },
    onKeyPress() {
      this.$emit('onKeyPress', this);
    },
    onKeyPressEnter() {
      this.$emit('onKeyPressEnter', this);
    },
    onKeyDownTab() {
      this.$emit('onKeyDownTab', this);
    },
    onBlur() {
      if (this.validationOnBlur) {
        this.validate_input();
      }
      this.$emit('onBlur', this);
    },
    onFocus() {
      this.$emit('onFocus', this);
    },
    onClick() {
      this.$emit('onClick', this);
    },
    onChange() {
      if (this.type === 'phone') this.input = `${this.activeCountryCode.code ? this.activeCountryCode.code : 1}${this.phoneInput}`;
      console.log("this.input", this.input);
      this.$emit('onChange', this);
    },
    validate_input() {
      //run required default validation
      if (this.required) {
        if (!this.input || `${this.input}`.length == 0 || this.input.length == 0) {
          this.isValid = false;
          this.validText = null;
          this.invalidText = ['This Field is Required'];
          return false//{isValid: false, errors: ['This Field is Required']}
        } else {
          this.isValid = true;
          this.validText = null;
          this.invalidText = null;
          return true;
        }
      }
      //run custom validation function
      if (this.validation) {
        let res = this.validation(this.input, this.dataSource);
        this.isValid = res.isValid;
        this.validText = res.correct ? res.correct : null;
        this.invalidText = res.errors ? res.errors : null;
        return res.isValid;
      } else if (this.validate) {
        switch (this.type) {
          case 'text':
            return true;
            break;
          case 'email':
            return true
            break;
          case 'number':
            return true;
            break;
          default:
            return true;
            break;
        }
      } else {
        return true;
      }
    },
    unmask(maskedValue) {
      if (this.mask !== null) {
        let defaultDelimiters = /[-!$%^&*()_+|~=`{}[\]:";'<>?,./\\ ]/;
        return maskedValue ? maskedValue.replace(new RegExp(defaultDelimiters, 'g'), '') : maskedValue;
      } else {
        return typeof maskedValue === 'string' ? (maskedValue.length > 0 ? maskedValue : null) : maskedValue;
      }
    }
  },
  data() {
    return {
      phoneInput: '',
      l_input: this.value,
      cacheImages: [],
      /*editorSettings: {
          modules: {
              toolbar: [
                  ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                  ['blockquote', 'code-block'],

                  [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                  [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                  [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                  [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
                  [{ 'direction': 'rtl' }],                         // text direction

                  [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                  [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                  [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                  [{ 'font': [] }],
                  [{ 'align': [] }],
              ]
          }
      },*/
      countryCodes: [
        {
          code: "1",
          flag: "https://icons.iconarchive.com/icons/wikipedia/flags/1024/US-United-States-Flag-icon.png",
          country: "eeuu"
        }
      ],
      activeCountryCode: null,
      editorSettingsSmall: {
        modules: {
          toolbar: [
            ['bold', 'italic', {'list': 'ordered'}, {'list': 'bullet'}, {list: "check"}, {'indent': '-1'}, {'indent': '+1'}] // toggled buttons
          ]
        }
      },
      isValid: null,
      validText: null,
      invalidText: null,
      showWysiwyg: true,
      id: null
    }
  }
}
</script>
<style>
.currency {
  max-width: 75%;
}

/*added for fields that aren't straight-forward input fields (phone, for example)*/
.is-invalid {
  border: 1px solid #dc3545;
  padding-right: calc(1.5em + .75rem)!important;
  background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(.375em + .1875rem) center;
  background-size: calc(.75em + .375rem) calc(.75em + .375rem);
}
</style>
